import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateStudentDebtReferenceResultType, CreateStudentDebtReferenceType, PaymentMethodType, ReferenceReportType } from '../../../types/Finance';

const initialState: ReferenceReportType = {
  references: [],
  data: {
      studentCode: '',
      fullname: '',
      studentId: '',
      enrollmentId: '',
      paymentTypeId: '',
      idSchoolBankConfig: '',
      bankEntity: '',
      semester: 0,
      year: 0
  } 
}

const referencesMethodSlice = createSlice({
  name: "references",
  initialState,
  reducers: {
    setReferencesData:(state, action:PayloadAction<ReferenceReportType>)=>({...state, ...action.payload}), 
    resetReferencesData :()=>({...initialState})
  }
});

    export const {setReferencesData,resetReferencesData} = referencesMethodSlice.actions

    export default referencesMethodSlice.reducer